import { render, staticRenderFns } from "./ItemSearchPartSelector.vue?vue&type=template&id=71ce06f4&scoped=true&"
import script from "./ItemSearchPartSelector.vue?vue&type=script&lang=ts&"
export * from "./ItemSearchPartSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ItemSearchPartSelector.vue?vue&type=style&index=0&id=71ce06f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce06f4",
  null
  
)

export default component.exports